import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const AboutUsSection = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 8, position: "relative", zIndex: 2 }}>
      <Grid container spacing={8} alignItems="center">
        {/* Left Section - Text Content */}
        <Grid item xs={12} md={6}>
          <Box>
            {/* Main Headline */}
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2.5rem", md: "3rem", lg: "3.5rem" },
                fontWeight: 700,
                fontFamily: "Outfit",
                color: "#FFFFFF",
                lineHeight: 1.2,
              }}
            >
              About Us
            </Typography>

            {/* Subtitle */}
            <Typography
              sx={{
                fontSize: "1.2rem",
                fontWeight: 600,
                fontFamily: "Outfit",
                color: "#5BF2FF",
                mb: 2,
              }}
            >
              Who we are
            </Typography>

            {/* Description */}
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                fontWeight: 400,
                fontFamily: "Outfit",
                color: "rgba(255, 255, 255, 0.9)",
                lineHeight: 1.6,
                maxWidth: "500px",
              }}
            >
              We’re a partner in your success. By blending technology with care,
              we help dietitian and nutritionists spend less time on admin work
              and more time empowering clients to live healthier lives. To
              simplify and automate nutrition practice management, so
              practitioners can focus on what truly matters: transforming lives
              through better health. We envision a world where nutritionists and
              dietitian are free from time consuming paperwork and can fully
              dedicate their expertise to creating lasting wellness for every
              individual.
            </Typography>
          </Box>
        </Grid>

        {/* Right Section - Image */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: { xs: "300px", md: "400px", lg: "450px" },
                height: { xs: "300px", md: "400px", lg: "450px" },
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
              }}
            >
              <Box
                component="img"
                src={require("assets/images/about3.png")}
                alt="About Us"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutUsSection;
